

class ProductModifierCell extends MUITableViewCell
{
    private nameLabel:MUILabel = null;
    private imageView:MUIImageView = null;
    private _separator = null;

    awakeFromHTML()
    {
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");

        this.separatorStyle = MUITableViewCellSeparatorStyle.None;
    }

    set item(i:any)
    {
        this.nameLabel.text = i.name;
    }

}